import React from 'react';
import Nav from './Nav';
import Footer from './Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100 ">
        <div className='p-6 '>
        <Nav/>
        </div>
       
      {/* Container */}
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg my-24 p-6">
        {/* Heading */}
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Privacy Policy
        </h1>

        {/* Content */}
        <div className="space-y-6 text-gray-700">
          <p>
          This Privacy Policy applies to Pravasa Travelling and Hospitality Pvt Ltd and its affiliates, subsidiaries, and divisions (collectively, "Company," "we," "us," or "our"). By accessing and using our website, mobile application, and services, you acknowledge and agree to the practices described in this Privacy Policy. We are committed to protecting your personal information and maintaining transparency regarding how we collect, use, disclose, and safeguard your data.          </p>

          <section>
            <p>
            Effective Date: 20/09/2023<br/>
Last Updated: 04/03/2025
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              1. Information We Collect
            </h2>
            <p>
            We collect personal and non-personal information in the following ways:
            Personal Information: Includes your name, contact details (email, phone number, address), payment details, government-issued identification, and any other details provided during registration, purchase, or inquiries.
            Personal Information: Includes your name, contact details (email, phone number, address), payment details, government-issued identification, and any other details provided during registration, purchase, or inquiries.
<p className='text-lg font-semibold text-gray-800 mb-2'>Demographic Information:</p> Age, gender, location, interests, and preferences.
<p className='text-lg font-semibold text-gray-800 mb-2'>Technical Information:</p>  IP address, device details, operating system, browser type, and site usage statistics.
<p className='text-lg font-semibold text-gray-800 mb-2'>Cookies and Tracking Data:</p> We use cookies and similar technologies to enhance your experience, analyse trends, and improve our services. </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              2. How We Use Your Information
            </h2>
            <p>
            We use collected information for the following purposes:
To provide and personalize our services.
To process transactions, bookings, and customer support requests.
To improve our website, mobile application, and marketing strategies.
To communicate with you regarding offers, updates, and promotions.
To ensure security, prevent fraud, and comply with legal obligations.            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              3. Sharing Your Information
            </h2>
            <p>
            We do not sell, rent, or trade your personal information. However, we may share your data with:
Service Providers: Third-party vendors who assist with payment processing, analytics, marketing, and customer support.
Legal and Compliance: Government agencies, law enforcement, or legal entities when required by law or in response to valid legal requests.
Business Transfers: In the event of a merger, sale, or acquisition, your information may be transferred to the new entity.            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              4. Data Security
            </h2>
            <p>
            We implement industry-standard security measures, including encryption and access controls, to protect your data. While we strive for data security, no transmission over the Internet is entirely secure. We encourage you to take precautions when sharing personal information online.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              5. Your Rights and Choices
            </h2>
            <p>
            Access and Correction: You can request access to, correction, or deletion of your personal data.
Opt-Out: You may opt-out of marketing communications by following the unsubscribe instructions in emails or contacting us.
Cookies Management: You can manage or disable cookies through your browser settings.            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              6. Retention of Data
            </h2>
            <p>
            We retain your personal information for as long as necessary to fulfill our business purposes and comply with legal obligations. If you wish to have your data deleted, you may contact us to request removal.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              7. International Data Transfers
            </h2>
            <p>
            If your data is transferred outside your country of residence, we ensure compliance with applicable data protection laws through safeguards such as standard contractual clauses or adequacy decisions.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              8. Links to Third-Party Sites
            </h2>
            <p>
            Our website may contain links to external sites. We are not responsible for the privacy practices of third-party websites, and we encourage you to review their privacy policies before sharing any information.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              9. Updates to This Policy
            </h2>
            <p>
            We may update this Privacy Policy periodically. Any changes will be posted on our website, and significant modifications will be communicated via email or notifications.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              10. Contact Us
            </h2>
            <p>
            If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at:
Email: support@pravasa.in
Mailing Address: 370 A second floor, Sant nagar, East of Kailash Delhi 110065            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-gray-600">
          <p>
            &copy; {new Date().getFullYear()} Pravasa.in. All rights reserved.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default PrivacyPolicy;